import {Component, OnDestroy, OnInit} from '@angular/core';
import {FinancialPosition} from "../../models/financial-position";
import {AuthService} from "../../../auth/services/auth.service";
import {FinancialPositionService} from "../../services/financial-position.service";
import {HeaderService} from "../../../tandem-core/services/header.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TandemUser} from "../../../auth/models/tandem-user";
import {Timestamp} from "firebase/firestore";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'tandem-edit-financial-position',
  templateUrl: './edit-financial-position.component.html',
  styleUrls: ['./edit-financial-position.component.scss']
})
export class EditFinancialPositionComponent implements OnInit, OnDestroy {

  userId: string | undefined;
  financialPositionId: string | null = null;
  financialPosition: FinancialPosition | undefined;
  user: TandemUser | null = null;
  constructor(private route: ActivatedRoute,
              private auth: AuthService,
              private financialPositionService: FinancialPositionService,
              private headerService: HeaderService,
              private router: Router) {
    this.financialPositionId = this.route.snapshot.paramMap.get('id');
  }

  private destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.auth.$user.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.user = user;
      this.userId = user?.id;
      if (user && this.financialPositionId) {
        this.financialPositionService.get(this.financialPositionId).subscribe(fp => {
          this.financialPosition = fp;
          this.headerService.setConfig({
            title: `Edit ${this.getTrackingToolName('single')}`,
            subtitle: this.getTrackingToolDescription(),
            breadcrumbs: [
              {
                label: `${this.getTrackingToolName('plural')}`,
                route: 'financial-positions'
              },
              {
                label: `${this.financialPosition?.title.replace(`${this.getTrackingToolName('single')} as of `, '')}`,
                route: `financial-positions/${this.financialPositionId}`
              },
              {label: 'Edit'}
            ]
          });
        })
      }
    });
  }

  onEdit(fp: FinancialPosition) {
    fp.dateModified = Timestamp.now()
    this.financialPositionService.update(fp).then(res => {
      this.router.navigate(['financial-positions']);
    })
  }

  getTrackingToolName(variant: 'single' | 'plural') {
    if (variant === 'single') {
      return this.user?.customTTMetadata?.fpName ? this.user.customTTMetadata.fpName : 'Financial Position';
    } else {
      return this.user?.customTTMetadata?.fpNamePlural ? `${this.user.customTTMetadata.fpNamePlural}` : 'Financial Positions';
    }
  }

  getTrackingToolDescription() {
    return !!this.user?.customTTMetadata?.fpDescription ? this.user.customTTMetadata.fpDescription : 'A summary of what you own, your assets, and what you owe, your liabilities at a given point in time'
  }
}
